'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var debugMode = require('./debugMode');
var xpath = require('../lib/xpath');

var utils = module.exports = {};

var trackPrefix = 'data-track-';
var hxtrackPrefix = 'data-hxtrack-';
var regexPatternForTrackingName = /[^a-z0-9-]/g;

utils.TRACKING_TYPES = {
  CLICK: 1,
  FOCUS: 2,
  CHANGE: 4,
  NONE: 0
};

var TRACKING_LEVELS = {
  checkbox: utils.TRACKING_TYPES.CLICK,
  radio: utils.TRACKING_TYPES.CLICK,
  INPUT: utils.TRACKING_TYPES.FOCUS | utils.TRACKING_TYPES.CHANGE,
  TEXTAREA: utils.TRACKING_TYPES.FOCUS | utils.TRACKING_TYPES.CHANGE,
  HTML: utils.TRACKING_TYPES.NONE,
  FORM: utils.TRACKING_TYPES.NONE,
  BODY: utils.TRACKING_TYPES.NONE
};

utils._trackingLevel = function (element) {
  if (element.type in TRACKING_LEVELS) {
    return TRACKING_LEVELS[element.type];
  }
  if (element.nodeName in TRACKING_LEVELS) {
    return TRACKING_LEVELS[element.nodeName];
  }
  return utils.TRACKING_TYPES.CHANGE | utils.TRACKING_TYPES.CLICK;
};

utils._getAttribute = function (element, attribute) {
  return element && element.getAttribute && element.getAttribute(attribute);
};

utils._getElement = function (event) {
  return event.target || event.srcElement;
};

utils._stringify = function (obj) {
  try {
    return JSON.stringify(obj);
  } catch (e) {
    return '';
  }
};

utils._getTarget = function (element, weCareAboutTrackingThisElement, originalElementForDebug) {
  if (!element) {
    return null;
  }
  var level = utils._trackingLevel(element);
  if (level) {
    weCareAboutTrackingThisElement = true;
    if (utils._getName(element)) return element;
  }
  return utils._getTarget(element.parentNode, weCareAboutTrackingThisElement, originalElementForDebug || element);
};

utils._replaceTrackingName = function (trackingName) {
  var transformTrackingName = trackingName.toLowerCase().replace(regexPatternForTrackingName, '-');

  return transformTrackingName;
};

utils._trackingNameReplaceAndValidate = function (trackingName) {
  var transformTrackingName = utils._replaceTrackingName(trackingName);
  var match = trackingName.match(regexPatternForTrackingName);
  if (match && match.length) {
    console.warn('\uD83D\uDEE4 Invalid tracking name found: ' + trackingName + ' Please read the documentation for Tracking Name Standards');
  }

  return transformTrackingName;
};

utils._elementChecks = function (element) {
  if (debugMode.get()) {
    var id = utils._getAttribute(element, 'id');
    var name = utils._getAttribute(element, 'name');
    var trackName = utils._getAttribute(element, trackPrefix + 'name');
    var hxtrackName = utils._getAttribute(element, hxtrackPrefix + 'name');

    if (!utils._getName(element)) {
      utils._handleTrackingErrors('No name found', element);
    }

    if (hxtrackName) {
      utils._handleTrackingErrors('Legacy name', element);
    }

    if (id && (name || trackName || hxtrackName)) {
      utils._handleTrackingErrors('Additional names', element);
    }

    var attribValue = utils._getAttribute(element, 'value'); // the value attribute, for an anchor say
    var trackValue = utils._getAttribute(element, trackPrefix + 'value'); // do we still need data-track-value?
    var hxtrackValue = utils._getAttribute(element, hxtrackPrefix + 'value');

    if ((element.value || attribValue) && (trackValue || hxtrackValue)) {
      utils._handleTrackingErrors('Additional values', element);
    }

    if (hxtrackValue) {
      utils._handleTrackingErrors('Legacy value', element);
    }
  }
};

utils._getName = function (element) {
  if (!element) return null;

  var id = utils._getAttribute(element, 'id');
  var name = utils._getAttribute(element, 'name');
  var trackName = utils._getAttribute(element, trackPrefix + 'name');
  var hxtrackName = utils._getAttribute(element, hxtrackPrefix + 'name');

  return id || name || trackName || hxtrackName;
};
function censorWithinLimits(start, end) {
  return function (char, count) {
    return count >= start && count < end ? '*' : char;
  };
}

utils._getValue = function (element) {
  if (!element) return undefined;

  var attribValue = utils._getAttribute(element, 'value'); // the value attribute, for an anchor say
  var trackValue = utils._getAttribute(element, trackPrefix + 'value'); // do we still need data-track-value?
  var hxtrackValue = utils._getAttribute(element, hxtrackPrefix + 'value');

  var value = element.value || attribValue || trackValue || hxtrackValue;

  // if someone clicks on a checkbox we need to know if it's checked or unchecked
  if (element.type === 'checkbox' && !element.checked) value = '';

  if (!value) return value; // don't try and censor null or undefined

  if (utils._getAttribute(element, 'type') === 'password') return '*';

  var nameAttribute = utils._getName(element);
  if (/(pass|keyphrase|pin)/i.test(nameAttribute)) return '*';

  var censored = utils._getAttribute(element, 'data-censor');

  if (!censored) return value;

  value = '' + value; // must be a string to censor part of it
  var start = 0;
  var end = value.length;
  var match = /first-(\d+)/.exec(censored);
  if (match) start = match[1];
  match = /last-(\d+)/.exec(censored);
  if (match) end -= match[1];
  return value.replace(/./g, censorWithinLimits(start, end));
};

utils._on = function (element, eventType, callback, bubbles, timeout) {
  var on = 'on' + eventType;
  if (element.addEventListener) element.addEventListener(eventType, callback, bubbles);else if (element.attachEvent) element.attachEvent(on, callback);else if (element[on]) element[on] = callback;else if (timeout) {
    // this option added only because orion supported it
    if (process.env.NODE_ENV !== 'production') {
      console.warn('we are in a browser that does not have window.onload');
    }
    setTimeout(callback, timeout);
  }
};
utils._handleTrackingErrors = function (message, element) {
  console.warn('\uD83D\uDEE4 ' + message + ' for element:', element);
  throw new Error(message);
};

utils._prepareErrorPayload = function (message, element) {
  var xpathStr = xpath._getXPath(element);
  var tags = [{
    name: 'x_path',
    string: xpathStr
  }];
  return {
    code: 'broken-tracking',
    message: message,
    info: '',
    source: 'client',
    supplier: 'website',
    exception: false,
    tags: tags
  };
};

var untrackedIds = [];
utils._setUntrackedIds = function (ids) {
  untrackedIds.length = 0;
  if (Array.isArray(ids)) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = ids[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var id = _step.value;
        typeof id === 'string' ? untrackedIds.push(id) : console.warn('untrackedIds must be a string');
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  } else {
    console.warn('Id\'s excluded from tracking must either be a single string or array of strings, received: ' + (typeof ids === 'undefined' ? 'undefined' : _typeof(ids)));
  }
};
utils._untrackedIds = untrackedIds;